import React from "react";
import { Link } from "react-router-dom";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

export default function ProviderPortfolioPage() {
  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>Portfolio</h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Manage provider media, showcase content, and public-facing brand presentation.
        </p>
      </section>

      <section style={cardStyle}>
        <h3 style={{ margin: 0, color: "#0f172a" }}>Portfolio actions</h3>
        <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginTop: "1rem" }}>
          <Link
            to="/provider/onboarding/portfolio"
            style={{
              textDecoration: "none",
              border: "1px solid #d1d5db",
              borderRadius: 12,
              padding: "0.8rem 1rem",
              color: "#111827",
              fontWeight: 700,
            }}
          >
            Open onboarding portfolio step
          </Link>
          <Link
            to="/provider/dashboard/media"
            style={{
              textDecoration: "none",
              border: "1px solid #d1d5db",
              borderRadius: 12,
              padding: "0.8rem 1rem",
              color: "#111827",
              fontWeight: 700,
            }}
          >
            Open media library
          </Link>
        </div>
      </section>
    </div>
  );
}